import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba9206ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "install-app-banner",
  role: "region",
  "aria-label": "Instalar la aplicación Galidancia"
}
const _hoisted_2 = { class: "install-app-banner__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "install-app-banner__text" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "App Galidancia"),
  /*#__PURE__*/_createElementVNode("span", null, "Accede más rápido desde tu móvil Android.")
], -1))
const _hoisted_4 = ["href"]

import { IonIcon } from '@ionic/vue';
import { closeOutline, phonePortraitOutline } from 'ionicons/icons';
import { useInstallAppBanner } from '@/composables/useInstallAppBanner';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallAppBanner',
  setup(__props) {

const { visible, dismiss, playStoreUrl } = useInstallAppBanner();

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonIcon), {
            icon: _unref(phonePortraitOutline),
            class: "install-app-banner__icon",
            "aria-hidden": "true"
          }, null, 8, ["icon"]),
          _hoisted_3,
          _createElementVNode("a", {
            class: "install-app-banner__cta",
            href: _unref(playStoreUrl),
            target: "_blank",
            rel: "noopener noreferrer"
          }, " Instalar ", 8, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            class: "install-app-banner__close",
            "aria-label": "Cerrar aviso de instalación",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(dismiss) && _unref(dismiss)(...args)))
          }, [
            _createVNode(_unref(IonIcon), {
              icon: _unref(closeOutline),
              "aria-hidden": "true"
            }, null, 8, ["icon"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})